<template>
  <div class="news">
    <div class="news-box">
      <div class="news-box-content">
        <div class="case-img-box">
          <img src="../assets/img/zixun_011.png" />
        </div>
        <div class="news-text-box">
          <div class="news-text-one">资讯动态</div>
        </div>
      </div>
    </div>
    <el-main
      v-loading="pictLoading"
      element-loading-text="加载中"
      element-loading-spinner="el-icon-loading"
    >
      <div class="news-content-box">
        <div class="news-content-list">
          <div
            class="news-content-one"
            v-for="(item,index) in caseList"
            :key="index"
            @click="toDetail(item)"
          >
            <div class="news-content-left" v-if="item.imageUrl">
              <img :src="item.imageUrl" />
            </div>
            <div class="news-content-none" v-else>
              <img src="../assets/img/u2586.png" />
            </div>
            <div class="news-content-right">
              <div class="news-content-title">{{item.title}}</div>
              <div
                class="news-conten-date"
                style="padding-right: 20px;margin-top: 40px;text-align: right;"
              >{{item.createTime}}</div>
            </div>
          </div>
        </div>
        <div class="page-box">
          <el-pagination
            background
            @current-change="handleSizeChange"
            :current-page.sync="pageNo"
            :page-size="pageSize"
            layout="prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </el-main>
  </div>
</template>
<script>
import { queryOpertionPublicityByClient } from '../api/publicinquiry.api.js';
export default {
  data() {
    return {
      caseList: [],
      total: 0,
      pageNo: 1,
      pageSize: 10,
      pictLoading: false
    };
  },
  methods: {
    handleSizeChange(page) {
      this.pageNo = page;
      this.getList();
    },
    toDetail(item) {
      this.$router.push({
        name: 'newsDetail',
        params: {
          Id: item.id
        }
      });
    },
    getList() {
      this.pictLoading = true;
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        type: 3
      };
      queryOpertionPublicityByClient(params).then(res => {
        // console.log(res);
        if (res.data) {
          this.total = res.data.count;
          this.caseList = res.data.list;
        }
        this.pictLoading = false;
      });
    }
  },
  created() {
    this.getList();
  }
};
</script>
<style>
.news {
  width: 100%;
}
.news-box {
  width: 100%;
  height: 650px;
  background: url('../assets/img/blue.png') no-repeat center;
  background-size: 100% 650px;
  overflow: hidden;
}
.news-box-content {
  display: flex;
  width: 1500px;
  height: 650px;
  margin: auto;
  overflow: hidden;
}
.news-img-box img {
  width: 600px;
  height: 600px;
  margin-top: 50px;
  margin-left: 30px;
}
.news-content {
  display: flex;
  width: 1500px;
  height: 650px;
  margin: auto;
  overflow: hidden;
}
.news-text-box,
.case-img-box {
  width: 50%;
}
.news-text-one {
  font-family: '微软雅黑 Bold', '微软雅黑 Regular', '微软雅黑';
  font-weight: 700;
  font-style: normal;
  font-size: 72px;
  color: #ffffff;
  margin-top: 150px;
  margin-left: 30%;
}
.news-content-box {
  width: 1500px;
  margin: auto;
}
.news-content-list {
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;
  overflow: hidden;
}
.news-content-one {
  display: flex;
  margin-top: 30px;
  width: 49%;
  height: 170px;
  box-shadow: rgba(204, 204, 204, 0.35) 3px 3px 5px;
  border: 1px solid rgb(215, 215, 215);
  cursor: pointer;
}
.news-content-right {
  width: 100%;
}
.news-content-one:hover .news-content-title {
  color: #08c0b9;
}
.news-content-one:nth-child(2),
.news-content-one:nth-child(4),
.news-content-one:nth-child(6),
.news-content-one:nth-child(8),
.news-content-one:nth-child(10) {
  margin-left: 20px;
}
.news-content-left img {
  width: 240px;
  height: 150px;
  margin-top: 10px;
  margin-left: 10px;
}
.news-content-none img {
  width: 150px;
  height: 150px;
  margin-top: 10px;
  margin-left: 10px;
}
.news-content-title {
  height: 55px;
  font-family: 微软雅黑;
  font-weight: 400;
  font-style: normal;
  font-size: 18px;
  color: rgb(0, 0, 0);
  line-height: 35px;
  padding: 20px;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.news-conten-date {
  padding-right: 20px;
  margin-top: 40px;
  text-align: right;
}
.page-box {
  text-align: center;
  margin-top: 30px;
  padding-bottom: 30px;
}
.el-icon-loading {
  color: #08c0b9 !important;
}
.el-loading-spinner .el-loading-text {
  color: #08c0b9 !important;
}
</style>
<style media="screen">
/*分辨率低于1280，采用下面的样式*/
@media screen and (max-device-width: 1500px) {
  .news-content-box,
  .news-box-content,
  .news-content {
    width: 1200px !important;
  }
  .news-content-one {
    width: 46% !important;
  }
  .news-content-one:nth-child(2),
  .news-content-one:nth-child(4),
  .news-content-one:nth-child(6),
  .news-content-one:nth-child(8),
  .news-content-one:nth-child(10) {
    margin-left: 42px !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/page/news.vue